export const selectHomeFeatures = (state) => state.home;
